import { ActionName } from '@invenco/common-domain/enums';

import { EditorAction, isConfiguredAction } from './editor-model';
import { getActionDefinition } from './field-registry';

// Canvas action-card summaries.

/** The param that best identifies an action at a glance; unreadable entity ids are omitted. */
const summaryParamKey: Partial<Record<ActionName, string>> = {
  ENSURE_ORDER_LINE: 'skuName',
  ENSURE_ORDER_LINE_DYNAMICALLY: 'skuName',
  SET_DELIVERY_INSTRUCTIONS: 'deliveryInstructions',
  SET_PACKING_INSTRUCTIONS: 'packingInstructions',
};

const formatValue = (value: unknown): string => {
  if (Array.isArray(value)) {
    return value.map(String).join(', ');
  }
  return value === undefined || value === null ? '' : String(value);
};

export function getActionSummary(action: EditorAction): string {
  if (!isConfiguredAction(action)) {
    return 'Select an action';
  }
  const title = getActionDefinition(action.type).title;
  const paramKey = summaryParamKey[action.type];
  const detail = paramKey ? formatValue((action.params as Record<string, unknown>)[paramKey]) : '';
  return detail ? `${title}: ${detail}` : title;
}
